import { CoreHistoryChartData, CoreHistoryModel } from '../models/history-data'
import { roundPositiveAndScale } from '../utils'

type Factor = 1 | 4

/**
 * Transform history data (fetched from database) to rechart data so they can be displayed in a system chart.
 *
 * @param dto
 * @param factor - 'day' view data needs to be scaled by 4
 * @returns
 */
export const fromCoreHistoryToRechartDataTransformer = (dto: CoreHistoryModel[], factor: Factor): CoreHistoryChartData[] => {
  return (
    dto?.map(dataPoint => {
      return {
        ...dataPoint,
        NetIn: roundPositiveAndScale(dataPoint.NetIn, factor),
        NetOut: roundPositiveAndScale(dataPoint.NetOut, factor),
        ConsumptionTotal: roundPositiveAndScale(dataPoint.Consumption, factor),
        ASOC: roundPositiveAndScale(dataPoint.ASOC, 1),
        DC_PowerSolar: roundPositiveAndScale(dataPoint.DC_Power, factor),
        DC_PowerL1: roundPositiveAndScale(dataPoint.DC_PowerL1, factor),
        DC_PowerL2: roundPositiveAndScale(dataPoint.DC_PowerL2, factor),
        DC_PowerL3: roundPositiveAndScale(dataPoint.DC_PowerL3, factor),
        BatPowerIn: roundPositiveAndScale(dataPoint.BatPowerIn, factor),
        BatPowerOut: roundPositiveAndScale(dataPoint.BatPowerOut, factor),
        Production: roundPositiveAndScale(dataPoint.Production, factor),
        ts: dataPoint.time,
      }
    }) ?? []
  )
}
